import { render, staticRenderFns } from "./thanks.vue?vue&type=template&id=3cec1bed&scoped=true&"
import script from "./thanks.vue?vue&type=script&lang=js&"
export * from "./thanks.vue?vue&type=script&lang=js&"
import style0 from "./thanks.vue?vue&type=style&index=0&id=3cec1bed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec1bed",
  null
  
)

export default component.exports